import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { DataProvider } from "./Admin/Components/Context/DataContext";
import { HotelProviders } from "./Admin/Components/Hotel/redux/providers";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <HotelProviders>
        <DataProvider>
          <App />
        </DataProvider>
      </HotelProviders>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
